<div
  *ngIf="isWeightScaleEnabled"
  class="p-grid p-nogutter waste-table waste-table__row waste-table__row--total waste-table__row--center">
  <div class="p-col-3">
    <div class="waste-table__row--flex">
      <i class="icon icon-scale"></i>
      <lib-button
        class="add-row__button"
        [disabled]="isScaleDisabled()"
        [label]="'WASTE_ASSIGNMENT.SCALE_UPDATE'"
        (clicked)="retrieveScaleMeasurement()"
      ></lib-button>
    </div>
  </div>
  <div class="p-col-3 col-form-label">
    <span>{{ quantity | formatQuantity }}</span>
  </div>
  <div class="p-col-3 col-form-label">
    <span>{{ weightDifference.value > 0 ? '+' : '' }}{{ weightDifference | formatQuantity }}</span>
  </div>
  <div class="p-col-3 col-form-label">
    <span>{{ 'WASTE_ASSIGNMENT.SCALE_WEIGHT_ABSOLUTE' | translate : { weight: weight | formatQuantity } }}</span>
  </div>
</div>
